import React from 'react';

export type AdminNoticeIntent = 'error' | 'success' | 'info';

interface Props {
  intent?: AdminNoticeIntent;
  children?: React.ReactNode;
  requestId?: string;
}

export default function AdminNotice({ intent = 'error', children, requestId }: Props) {
  if (children == null || children === false || children === '') return null;
  const role = intent === 'error' ? 'alert' : 'status';
  return (
    <p className={`admin-notice admin-notice--${intent}`} role={role}>
      {children}
      {requestId && (
        <span className="admin-notice__request-id">{requestId}</span>
      )}
    </p>
  );
}
